import {cart} from '@/app/js/cart'

export function initUpsell() {
  const upsellAddElements = document.querySelectorAll('.js-upsell-add')

  for (const upsellAddEl of upsellAddElements) {
    upsellAddEl.addEventListener('click', () => {
      cart.addUpsell(upsellAddEl.dataset.productId, upsellAddEl.dataset.upsellId)
        .then(() => {
          location.reload()
        })
    })
  }
}
